import React, { Component, Suspense } from "react";
import axios from "axios";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import "./Payment.scss";
import PaymentSuccess from "./../../../../src/images/payment-success.svg";
import PaymentFailed from "./../../../../src/images/payment-failed.svg";
import ContentLoader from "react-content-loader";
import { Translation } from 'react-i18next';
const CardLoader = () => (
   <ContentLoader height={320}>
      <rect x="30" y="6" rx="2" ry="2" width="344" height="22" />
      <rect x="80" y="51" rx="2" ry="2" width="236" height="172" />
      <rect x="29" y="252" rx="2" ry="2" width="344" height="12" />
      <rect x="29" y="282" rx="2" ry="2" width="344" height="30" />
   </ContentLoader>
);

class OrderTreePublic extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loggedIn: false,
         loading: true,
         orderStatus: null,
         totalTree: null,
         grandTotal: null,
         hitGetActions: 0,
      };
   }

   getPaymentStatus = (id) => {
      axios
      .get(
         process.env.REACT_APP_API_HOST +
         "/order/tree/new/status/" +
         id
      )
      .then((res) => {
         // console.log("payment detail res ", res.data.data.paid);
         if (res.data.status) {
            setTimeout(() => {
               this.setState({
                  orderStatus: res.data.data.paid,
                  totalTree: res.data.data.totalTree,
                  grandTotal: res.data.data.total,
                  loading: false,
               });
            }, 2000);
         } else {
            console.log('false')
            if(res.data.errors.length !== 0){
               setTimeout(() => {
                  this.setState({
                     errorState: true,
                     errors: res.data.errors,
                     loading: false,
                  });
               }, 2000);
            } else {
               setTimeout(() => {
                  this.setState({
                     orderStatus: res.data.data.paid,
                     totalTree: res.data.data.totalTree,
                     grandTotal: res.data.data.total,
                     loading: false,
                  });
               }, 2000);
            }
         }  
      });
   }
   componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const order_id = query.get("order_id");
      setTimeout(() => {
         this.getPaymentStatus(order_id);
      }, 4000);
      
   }
   render() {
      return (
         <div className="mpl-page login">
            <Suspense fallback={"...Loading"}>
               <Translation>
                  {(t, { i18n }) => (
               <div className="container">
                  <div className="row">
                     <div className="col align-self-center">
                        <div
                           className="card box-shadow"
                           style={{ width: "100%", maxWidth: "500px", margin: "auto" }}
                        >
                           {this.state.loading ? (
                              <div
                                 className="card-body text-center"
                                 style={{ minHeight: "300px" }}
                              >
                                 <CardLoader />
                              </div>
                           ) : (
                              <div
                                 className="card-body text-center"
                                 style={{ minHeight: "300px" }}
                              >
                                 {this.state.orderStatus ? (
                                    <React.Fragment>
                                       <h2
                                          className="text-green text-bold lh-32"
                                          style={{ fontSize: "20px", lineHeight: "26px" }}
                                       >
                                          {t('ThanksForCaringEarth')}
                                       </h2>
                                       <img
                                          src={PaymentSuccess}
                                          alt="Payment Success"
                                          style={{ width: "100%", maxWidth: "240px" }}
                                       />
                                       <br />
                                       <p className="lh-22 text-gray text-small mb-4">
                                          {t('WeveReceiveYourTransaction')}&nbsp;
                                          <b className="text-green text-bold">
                                             Rp.{" "}
                                             <NumberFormat
                                                value={this.state.grandTotal}
                                                displayType={"text"}
                                                decimalScale={0}
                                                thousandSeparator={"."}
                                                decimalSeparator={","}
                                             />
                                          </b>{" "}
                                          <br />
                                       </p>
                                       <Link
                                          to={`/`}
                                          className="btn btn-green btn-block text-center"
                                       >
                                          {t('BackToCarbonCalculator')}
                                       </Link>
                                       <br />
                                    </React.Fragment>
                                 ) : (
                                    <React.Fragment>
                                       <h2 className="text-red text-bold lh-32">
                                          {t('Failed')} <br />
                                       </h2>
                                       <img
                                          src={PaymentFailed}
                                          alt="Payment Failed"
                                          style={{ width: "100%", maxWidth: "240px" }}
                                       />
                                       <br />
                                       <p className="lh-22 text-gray text-small mb-4">
                                          {t('YourPaymentIsFailed')}
                                       </p>
                                       <Link
                                          to={`/`}
                                          className="btn btn-green btn-block text-center"
                                       >
                                          {t('BackToCarbonCalculator')}
                                       </Link>
                                    </React.Fragment>
                                 )}
                              </div>
                           )}
                        </div>
                     </div>
                  </div>
               </div>
               )}
               </Translation>
            </Suspense>
         </div>
      );
   }
}

export default OrderTreePublic;
